<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="false"
  class="fertility-summary"
>
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between">
      <app-production-picker
        (productionChanged)="onProductionChanged($event)"
      ></app-production-picker>
    </div>

    @if (hasData()) {
      <div class="flex__child--auto">
        <div class="table-desktop">
          <table
            mat-table
            #table
            [dataSource]="dataSource"
            class="table-desktop__table--alternate-rows cust-table"
          >
            @for (column of columnIds(); track column; let colIndex = $index) {
              <ng-container matColumnDef="{{ column }}">
                <th mat-header-cell *matHeaderCellDef>
                  <div>
                    {{ columns[colIndex].label | translate }}
                  </div>
                </th>
                <td mat-cell *matCellDef="let row">
                  @if (columns[colIndex].type === 'string') {
                    <div>{{ row[column] }}</div>
                  }
                  @if (columns[colIndex].type === 'value' && row[column].value) {
                    <div>
                      {{ row[column]?.value | number: row[column]?.format }}
                      <button mat-button (click)="openDrillCowList(row[column].list)">
                        ({{ row[column]?.count | number: '0.0-0' }})
                      </button>
                    </div>
                  }
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="columnIds()"></tr>
            <tr mat-row *matRowDef="let row; columns: columnIds()"></tr>
          </table>
        </div>
      </div>
    }
    <agr-notification-empty
      [isEmpty]="!hasData()"
      [emptyTitle]="'no_items' | translate"
      emptyImage="/assets/images/no-items.png"
      class="complete__notification-empty"
    >
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
